<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible1"
        :close-on-click-modal="false"
        :modal="false"
        title="编辑"
        width="700px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="eMRepairOrderWord"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="维修内容">
            <el-input v-model="eMRepairOrderWord.repairContent" placeholder="请输入" type="textarea"/>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible1=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  export default {
    name:"EMRepairOrderWordEdit",
    components: {},
    data() {
      return {
        constant,
        dialogVisible1: false,
        contentLoading: false,
        submitLoading: false,
        index: "",
        eMRepairOrderWord: {
          repairContent: "",
        },
        ruleValidate: {
          // fileName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(val,index) {
        this.index = index;
        this.eMRepairOrderWord.repairContent = val;
        this.dialogVisible1 = true;
      },
      handleSubmit() {
        console.log(this.eMRepairOrderWord.repairContent,this.index);
        this.$emit("getRepairContent",this.eMRepairOrderWord.repairContent,this.index);
        this.dialogVisible1 = false;
      },
    },
  };
</script>

<style lang="scss">
  .col{
    .el-select{
      width: 60%;
    }
  }
  .col:last-child{
    .el-select{
      width: 72%;
      input{
        padding-right: 25px;
      }
    }
  }
</style>
